module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/blog/test.md absPath of file >>> MarkdownRemark","html":"<p>test</p>","fields":{"slug":"/blog/test/"},"frontmatter":{"date":"April 06, 2018","title":"test","cover":"/img/coffee-gear.png","meta_title":"test","meta_description":"test","tags":["test"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/blog/test.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-test.json
// module id = 423
// module chunks = 23419474955521